import useLessonBox from '@/components/_deprecated/courses/box/lesson/LessonBox.hooks';
import { LessonBoxService } from '@/components/_deprecated/courses/box/lesson/LessonBoxService';
import { LessonBoxSkeleton } from '@/components/_deprecated/courses/box/skeletons/CourseBoxSkeletons';
import TopicsContainer from '@/components/topics/TopicsContainer';
import { scrollBarClassName } from '@/utils/scrollBarClassName';
import { useOutletContext } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { useCoursePath } from '../studio/CourseStudio.hooks';

type OutletContextType = {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
};

export function LessonBox() {
  const { setIsEditing } = useOutletContext<OutletContextType>();
  const { coursePath } = useCoursePath();

  const { lesson, block, isLoading } = useLessonBox();

  if (isLoading) return <LessonBoxSkeleton />;

  if (!lesson || !coursePath) return null;

  return (
    <TopicsContainer
      className={twMerge(
        'relative grow flex flex-col gap-2.5 border-neutral-content',
        scrollBarClassName,
      )}
    >
      <LessonBoxService
        key={lesson.order}
        lesson={lesson}
        block={block}
        coursePath={coursePath}
        onEdit={setIsEditing}
      />
    </TopicsContainer>
  );
}
